
<div>
    <div class="ui label warning-label" style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
      " *ngIf="message">
      <div>{{ message }}</div>
      <button *ngIf="redirect_url" style="margin-top: 15px" class="ui primary button">
        <a (click)="redirectToExternalUrl()" style="color: white">
          Go back to {{ applicationType }} application
        </a>
      </button>
    </div>
    <!-- <div class="ui secondary sub pointing menu" appMargin marginB="8">
      <div class="ui item" [routerLink]="['./official']" routerLinkActive="active">
        Official Documents
      </div>
      <div class="ui item" [routerLink]="['./archive']" routerLinkActive="active">
        Archived Documents
      </div>
    </div> -->
  
    <h2 class="doc-header">Supporting Documents</h2>
    <div class="ui divider"></div>
    <router-outlet></router-outlet>
  </div>